import {
  AGENT_PROFILE_LOOKUP,
  GET_AGENT_PROFILE,
  TRIGGER_SWITCH_USER,
  agentProfileState,
  getAgentBranding,
  resetAgentContacts,
  resetBuySellRequestProposalData,
  resetInsuredDefaultvalue,
  resetUserInviteDetailsState,
  setActiveIndex,
  setGoingToSAManagerProfile,
  setIsAgent,
  setIsComingFromURL,
  setIsNotOwnProfile,
} from "app/redux";
import {
  TRIGGER_STORE_IS_FORM_ACTIVE_DATA,
  getIsFormActiveData,
} from "app/redux/features/IsFormActive";
import { TRIGGER_STORE_DASHBOARD_DATA, getDashboardData } from "app/redux/features/dashboard";
import {
  TRIGGER_STORE_IS_AGENCY_MANAGER_ACTIVE_DATA,
  getIsAgencyManagerActiveData,
} from "app/redux/features/isAgencyActive";
import { logoutResponseState } from "app/redux/features/logout";
import { RootState } from "app/store";
import BlockPopup from "app/uicomponents/microcomponents/BlockPopup";
import {
  clearSessionStore,
  getObjectFromSessionStore,
  getSessionStore,
  removeSessionStore,
  setObjectInSessionStore,
  setSessionStore,
} from "app/utils/sessionStore";
import { THEME, USERTYPE } from "app/utils/types";
import Cookies from "js-cookie";
import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { Sidebar } from "primereact/sidebar";
import { isEmpty } from "ramda";
import {
  Dispatch,
  FC,
  MutableRefObject,
  ReactNode,
  SetStateAction,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Branding, GroupItems, SidebarItem, SidebarSubItem } from "../../../Data/types/Dashboard";
import SVG from "../../../assets/DefaultProfile.svg";
import IAPPLogoDarkIcon from "../../../assets/IAPPLogoDarkIcon.svg";
import "../../../css/Sidebar.css";
// import { Image } from "primereact/image";
import ExitIcon from "app/assets/IconComponent/ExitIcon";
import PendingIcon from "app/assets/IconComponent/PendingIcon";
import PlanIcon from "app/assets/IconComponent/PlanIocn";
import ProposalsIcon from "app/assets/IconComponent/ProposalsIcon";
import RelationshipIcon from "app/assets/IconComponent/RelationshipIcon";
import useDarkTheme from "app/hooks/useDarkTheme";
import ThemeSelector from "app/pages/InteractiveProposal/menuPages/Header/ThemeSelector";
import { TRIGGER_SAVE_THEME_SETTINGS } from "app/redux/features/agent-branding";
import { getAuthSwitch, resetAuthSwitchData } from "app/redux/features/auth-switch";
import {
  contactProfileLookUP,
  resetContactProfileLookup,
} from "app/redux/features/contact-profile-lookup";
import TriggerLogoutRequest from "app/redux/features/logout/action";
import { getObjectFromLocalStore, removeLocalStore, setLocalStore } from "app/utils/localStore";
import { makeRequest } from "app/utils/makeRequest";
import { getCookieDomain, userTypeForAdvisor } from "app/utils/utils";
import { getIsNewDesign } from "app/utils/isNewDesign";
import PrimeReact from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";
import { TieredMenu } from "primereact/tieredmenu";
import { Toast } from "primereact/toast";
import { Tooltip } from "primereact/tooltip";
import educationDarkSVG from "../../../assets/EducationDark.svg";
import educationLightSVG from "../../../assets/EducationLight.svg";
import resourcesSVG from "../../../assets/resourcesDark.svg";
import resourcesLightSVG from "../../../assets/resourcesLight.svg";
import afrDarkSVG from "../../../assets/svg/AFRDark.svg";
import afrLightSVG from "../../../assets/svg/AFRLight.svg";
import contactsDarkSVG from "../../../assets/svg/ContactsDark.svg";
import contactsSVG from "../../../assets/svg/ContactsLight.svg";
import dashboardDarkSVG from "../../../assets/svg/DashboardDark.svg";
import dashboardSVG from "../../../assets/svg/DashboardLight.svg";
import insuranceCompanyDarkSVG from "../../../assets/svg/InsuranceCompanyDark.svg";
import insuranceCompanyLightSVG from "../../../assets/svg/InsuranceCompanyLight.svg";
import milestonesDarkSVG from "../../../assets/svg/MilestonesDark.svg";
import milestonesLightSVG from "../../../assets/svg/MilestonesLight.svg";
import pendingSVG from "../../../assets/svg/PendingDark.svg";
import pendingLightSVG from "../../../assets/svg/PendingLight.svg";
import plansSVG from "../../../assets/svg/PlansDark.svg";
import plansLightSVG from "../../../assets/svg/PlansLight.svg";
import proposalsDarkSVG from "../../../assets/svg/ProposalsDark.svg";
import proposalsSVG from "../../../assets/svg/ProposalsLight.svg";
import provisionsDarkSVG from "../../../assets/svg/ProvisionsDark.svg";
import provisionsLightSVG from "../../../assets/svg/ProvisionsLight.svg";
import reportsDarkSVG from "../../../assets/svg/ReportsDark.svg";
import reportsSVG from "../../../assets/svg/ReportsLight.svg";
import hiveStudioLightSVG from "../../../assets/HiveStudioLight.svg";
import hiveStudioDarkSVG from "../../../assets/HiveStudioDark.svg";
import subscribersLightSVG from "../../../assets/SubscribersLight.svg";
import subscribersDarkSVG from "../../../assets/SubscribersDark.svg";
import adCenterLightSVG from "../../../assets/AdCenterLight.svg";
import adCenterDarkSVG from "../../../assets/AdCenterDark.svg";
import pipelineLightSVG from "../../../assets/PipelineLight.svg";
import pipelineDarkSVG from "../../../assets/PipelineDark.svg";
import masterDataLightSVG from "../../../assets/MasterDataLight.svg";
import masterDataDarkSVG from "../../../assets/MasterDataDark.svg";
import portfolioLightSVG from "../../../assets/PortfolioLight.svg";
import portfolioDarkSVG from "../../../assets/PortfolioDark.svg";
import beeLightSVG from "../../../assets/BeeLight.svg";
import beeDarkSVG from "../../../assets/BeeDark.svg";
import TruncatedText from "../../microcomponents/TruncatedText";
import { HexagonImage } from "../HexagonImage";
import FinancingIcon from "app/assets/IconComponent/FinancingIcon";
import PortfolioIcon from "app/assets/IconComponent/PortfolioIcon";

const DashboardLeftPanel: FC<{
  fields: SidebarItem[];
  branding: Branding;
  badgeCount?: { [key: string]: number };
  assistantAgentList?: any;
}> = ({ fields, branding, badgeCount, assistantAgentList }) => {
  const defaultProfilePicture: string = SVG;
  const [visible, setVisible] = useState(true);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [menu, setMenu] = useState<SidebarItem[]>([]);
  const [menuCurrentId, setMenuCurrentId] = useState<string>();
  const [nextRouterUrl, setNextRouterUrl] = useState<string>("");
  const [expandedMenuId, setExpandedMenuId] = useState<string | null>(null);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { isFormActive } = useSelector(getIsFormActiveData);
  const [isBlockVisible, setIsBlockVisible] = useState(true);
  const scrollRef = useRef<HTMLUListElement | null>(null);
  const [popUpDisplay, setPopupDisplay] = useState<boolean>(false);
  const [getAgencyBranding, setAgencyBranding] = useState<any>();
  const agencyBranding = getObjectFromSessionStore("agencyBrandings");
  const { data: agentProfileData } = useSelector(agentProfileState);
  const { data } = useSelector(getDashboardData);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast: MutableRefObject<any> = useRef(null);
  const menuRef = useRef<TieredMenu>(null);
  const { isAgencyManagerActive } = useSelector(getIsAgencyManagerActiveData);
  const { data: agencyProfileData } = useSelector(agentProfileState);
  const { data: lookupData } = useSelector(contactProfileLookUP);
  const [selectedValue, setSelectedValue] = useState(null);
  const { postAuthSwitchSuccess } = useSelector(getAuthSwitch);
  const assistantAgentObject = getObjectFromLocalStore("assistantAgentUserAccess");
  const userAccess = getObjectFromLocalStore("useraccess");
  const isNewDesignEnabled = getIsNewDesign();

  // Get shouldShowReports from assistantAgentUserAccess object in localStorage
  const getShouldShowReports = (): boolean => {
    try {
      const assistantAgentData = assistantAgentObject;
      if (assistantAgentData?.shouldShowReports !== undefined) {
        return assistantAgentData.shouldShowReports;
      }
      return true; // Default value
    } catch {
      return true; // Default value on error
    }
  };

  const [shouldShowReports, setShouldShowReports] = useState<boolean>(getShouldShowReports());
  const theme = getSessionStore("globalTheme");
  const [primaryLogo, setPrimaryLogo] = useState("");
  const [secondaryLogo, setSecondaryLogo] = useState("");
  const [localLookup, setLocalLookup] = useState(getObjectFromSessionStore("lookUpResponse"));
  const { settingThemeData, activeBrandingSuccess, dataBranding } = useSelector(getAgentBranding);
  const assistantAgentListNames = assistantAgentList.map((item: any) => ({
    label: item?.name,
    value: item?.id,
  }));
  const [, setTheme]: [string, Dispatch<SetStateAction<string>>] = useDarkTheme();
  const [themeState, setThemeState] = useState(typeof theme === "string" ? theme : "");
  const [actionOnDiscardChanges, setActionOnDiscardChanges] = useState<
    "PROFILE" | "SETTING" | "SWITCH_TO_AGENCY" | null
  >(null);
  const [loader, setLoader] = useState(false);
  const { logoutSuccess } = useSelector(logoutResponseState);
  const agentProfile = getObjectFromSessionStore("agentlookUpResponse");
  const agentLookUpResponse = useSelector((state: RootState) => state?.agentProfileLookup);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [agentBrandingData, setAgentBrandingData] = useState(null);

  useEffect(() => {
    const updatedTheme = settingThemeData?.body?.theme;
    if (typeof updatedTheme === "string" && updatedTheme !== themeState) {
      setThemeState(updatedTheme);
    }
  }, [settingThemeData]);

  function initializeMenu(menuList: SidebarItem[], path: string) {
    const countForwardSymbol = (path.match(/\//g) || []).length;
    const pathArr = path.substring(1).split("/");
    return menuList.map((menuItem) => {
      const group = menuItem.groupItems.map((grpItem) => {
        // Ensure "Plan Pricing" appears under Master Data in the sidebar
        let updatedGroupItems = grpItem.groupItems;
        if (grpItem.label === "Master Data") {
          const hasPlanPricing =
            updatedGroupItems?.some((subItem) => subItem.label === "Plan Pricing") ?? false;
          if (!hasPlanPricing) {
            updatedGroupItems = [
              ...(updatedGroupItems || []),
              {
                id: `${grpItem.id}-planpricing`,
                label: "Plan Pricing",
                isActive: false,
              },
            ];
          }
        }
        let updatedGroupItem = {
          ...grpItem,
          groupItems: updatedGroupItems,
          isActive:
            window?.location?.hash?.includes("agent") && grpItem?.label === "Subscribers"
              ? true
              : grpItem.label === "Contacts" && pathArr.length > 1
              ? false
              : grpItem?.link
              ? pathArr[0] === grpItem?.link?.substring(1)
              : updatedGroupItems?.some((item) => pathArr[0] === item?.link?.substring(1)),
        };

        if (updatedGroupItems?.length) {
          updatedGroupItem = {
            ...updatedGroupItem,
            groupItems: updatedGroupItems.map((subMenuItem: SidebarSubItem) => {
              const customLabel =
                subMenuItem.label === "Requests For Proposals" ? "Requests" : subMenuItem.label;
              const active =
                pathArr.findIndex(
                  (name) => name === `${customLabel.replace(/\s/g, "")}`.toLowerCase(),
                ) > 0 && countForwardSymbol > 1;

              // Portfolio and Pipeline group active menu check
              const isActiveForCombineMenu = pathArr[0] === subMenuItem?.link?.substring(1);
              return {
                ...subMenuItem,
                label: customLabel,
                isActive: active || isActiveForCombineMenu,
              };
            }),
          };
        }
        return updatedGroupItem;
      });
      return { ...menuItem, groupItems: group };
    });
  }
  // Update localStorage when assistant selects an advisor from dropdown
  // useEffect(() => {
  //   // Default: show Reports (true) unless assistant selects advisor without permissions
  //   let newShouldShow = true;

  //   if (userAccess?.isAssistant) {
  //     const currentSelectedValue =
  //       selectedValue || assistantAgentObject?.selectedAssistantAgentOption;
  //     if (currentSelectedValue && assistantAgentList?.length > 0) {
  //       const selectedAdvisor = assistantAgentList.find(
  //         (item: any) => item.id === currentSelectedValue,
  //       );
  //       // Only hide Reports if advisor doesn't have required permissions
  //       newShouldShow =
  //         selectedAdvisor?.viewCommission === true || selectedAdvisor?.hasAdviserRole === true;
  //     }
  //     // If no advisor is selected, newShouldShow remains true (default)
  //   }
  //   // If user is not assistant, newShouldShow remains true (default)

  //   // Only update if value actually changed to prevent infinite loops
  //   if (prevShouldShowRef.current !== newShouldShow) {
  //     setShouldShowReports(newShouldShow);
  //     // Update shouldShowReports inside assistantAgentUserAccess object
  //     const currentAssistantData = assistantAgentObject;
  //     if (currentAssistantData) {
  //       const updatedAssistantData = {
  //         ...currentAssistantData,
  //         shouldShowReports: newShouldShow,
  //       };
  //       setLocalStore("assistantAgentUserAccess", updatedAssistantData);
  //     }
  //     prevShouldShowRef.current = newShouldShow;
  //   }
  // }, [selectedValue, assistantAgentObject, assistantAgentList, userAccess?.isAssistant]);

  useEffect(() => {
    if (!isEmpty(postAuthSwitchSuccess?.data)) {
      const updateDataList = { ...postAuthSwitchSuccess.data };
      const filteredData = assistantAgentList.filter((item: any) => item.id === selectedValue);
      updateDataList.selectedAssistantAgentOption = selectedValue;
      updateDataList.viewCommission = filteredData?.[0]?.viewCommission;
      updateDataList.hasAdviserRole = filteredData?.[0]?.hasAdviserRole;

      // Calculate and store shouldShowReports inside assistantAgentUserAccess object
      const shouldShow = userAccess?.isAssistant
        ? filteredData?.[0]?.viewCommission === true || filteredData?.[0]?.hasAdviserRole === true
        : true;
      updateDataList.shouldShowReports = shouldShow;
      setLocalStore("assistantAgentUserAccess", updateDataList);

      setShouldShowReports(shouldShow);

      navigate("/proposal/drafts");
      dispatch(resetAuthSwitchData());
      dispatch({
        type: AGENT_PROFILE_LOOKUP,
        payload: {
          address: "lookupAfterAgent",
        },
      });
    }
  }, [postAuthSwitchSuccess?.data]);

  useEffect(() => {
    if (!isEmpty(agencyBranding) && !getAgencyBranding) {
      setAgencyBranding(agencyBranding);
    }
  }, [agencyBranding, agentProfileData]);

  useEffect(() => {
    setIsCollapsed(data);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLocalLookup(getObjectFromSessionStore("lookUpResponse"));
    }, 0);
  }, [lookupData]);

  const agencyBrandingData = getObjectFromSessionStore("activeBrandingUser");
  const hasAgencyBrandingData = agencyBrandingData?.primaryLogo;

  const agentCurrentBranding = sessionStorage.getItem("agentCurrentBranding");

  useEffect(() => {
    if (
      isAgencyManagerActive &&
      !hasAgencyBrandingData &&
      agencyProfileData?.agency?.currentBranding?.length > 0
    ) {
      let currAgency = agencyProfileData?.agency;
      if (agencyProfileData?.agency?.currentBranding === "parentAgency") {
        currAgency = agencyProfileData?.agency?.parentAgency;
      }
      setObjectInSessionStore("activeBrandingUser", {
        activeUserType: agencyProfileData?.agency?.currentBranding,
        primaryLogo:
          agencyProfileData?.agency?.currentBranding === "iapp"
            ? process.env.REACT_APP_ENVIRONMENT === "PROD"
              ? `${process.env.REACT_APP_ASSET_URL_PROD}/iapp_color.png`
              : `${process.env.REACT_APP_ASSET_URL_DEV}/iapp_color.png`
            : currAgency?.AgencyBrandings?.[0]?.primaryLogo ||
              (process.env.REACT_APP_ENVIRONMENT === "PROD"
                ? `${process.env.REACT_APP_ASSET_URL_PROD}/iapp_color.png`
                : `${process.env.REACT_APP_ASSET_URL_DEV}/iapp_color.png`),
        secondaryLogo:
          agencyProfileData?.agency?.currentBranding === "iapp"
            ? process.env.REACT_APP_ENVIRONMENT === "PROD"
              ? `${process.env.REACT_APP_ASSET_URL_PROD}/bee_icon.png`
              : `${process.env.REACT_APP_ASSET_URL_DEV}/BEE+ICON.png`
            : currAgency?.AgencyBrandings?.[0]?.secondaryLogo,
      });
      dispatch({
        type: GET_AGENT_PROFILE,
        payload: {
          address: "agencyProfile",
        },
      });
    }
  }, [agencyProfileData]);

  const userType = getSessionStore("type");
  const agentProfileId =
    userAccess.userType === USERTYPE.ADMIN && userType === "agency"
      ? getSessionStore("managerId")
      : userAccess.userType === USERTYPE.ADMIN && userType === "subAgency"
      ? getSessionStore("subAgencyManagerId")
      : userAccess.userType === USERTYPE.ADMIN || pathname === "/agent/branding"
      ? getSessionStore("agentProfileId")
      : assistantAgentObject?.selectedAssistantAgentOption
      ? assistantAgentObject?.selectedAssistantAgentOption
      : "";

  useEffect(() => {
    if (!isAgencyManagerActive) {
      makeRequest("allBrandingDetails")
        .get(
          userAccess.userType === USERTYPE.ADMIN || pathname === "/agent/branding"
            ? `userId=${agentProfileId}`
            : "",
          false,
          userAccess.userType === USERTYPE.ADMIN || pathname === "/agent/branding",
        )
        .then((res) => {
          const currentBrandingType = res.data?.data?.currentBranding;
          const currentBrandingRecord =
            res.data?.data?.brandingData?.find((dt: any) => dt?.userType === currentBrandingType) ||
            null;
          setAgentBrandingData(
            res.data?.data?.brandingData?.find(
              (dt: any) => dt?.userType === res.data?.data?.currentBranding,
            ),
          );
          setObjectInSessionStore("activeBrandingUser", {
            activeUserType: currentBrandingType,
            brandingData: currentBrandingRecord ? [currentBrandingRecord] : [],
          });
        });
    } else {
      setAgentBrandingData(null);
    }
  }, [isAgencyManagerActive, activeBrandingSuccess, dataBranding]);

  function handleMenuSelection(
    arr: SidebarItem[] | GroupItems[],
    itemId: string,
    isParentActive?: boolean,
  ): SidebarItem[] {
    return arr.map(
      (item, index) =>
        ({
          ...item,
          isActive:
            item.id === itemId ||
            item.groupItems?.some((child) => child.isActive) ||
            (isParentActive && index === 0),
          ...(item.groupItems && {
            groupItems: handleMenuSelection(item.groupItems as GroupItems[], itemId),
          }),
        } as SidebarItem),
    );
  }
  const handleButtonClick = () => {
    setIsBlockVisible((prevState) => !prevState);
  };

  useEffect(() => {
    let interVal: NodeJS.Timeout;
    if (pathname.startsWith("/contacts")) {
      const menuItem = menu.find(
        (el) => el.groupItems.findIndex((item) => item.label === "Relationship") >= 0,
      );
      const subMenuItem = menuItem?.groupItems.find((item) => item.label === "Relationship");
      if (!subMenuItem?.isActive) {
        interVal = setTimeout(() => {
          const updatedMenu = handleMenuSelection(menu, subMenuItem?.id as string);
          setMenu(updatedMenu);
        }, 10);
      }
    }

    return () => {
      clearTimeout(interVal);
    };
  }, [pathname, menu]);

  useEffect(() => {
    if (!isEmpty(logoutSuccess)) {
      const hostName = window.location.host;
      const firstHostName = hostName.split(".")[0];
      const noSubDomain =
        firstHostName.startsWith("localhost") ||
        firstHostName === "dev" ||
        firstHostName === "qa" ||
        firstHostName === "iAPP" ||
        firstHostName === "bs-dev" ||
        firstHostName === "uat" ||
        firstHostName === "bs-qa" ||
        firstHostName === "neio-qa";
      if (!noSubDomain) {
        const cookieDomain = getCookieDomain();
        Cookies.remove("authData", {
          path: "/",
          domain: cookieDomain,
        });
        window.location = localLookup?.branding?.domain;
        clearSessionStore();
      }
    }
  }, [logoutSuccess, localLookup]);

  const navigateHandler = () => {
    const userTypeRoutes = {
      agent:
        userAccess?.parentAgencyId !== null && isAgencyManagerActive
          ? "/sub-agency/profile"
          : isAgencyManagerActive
          ? "/profile/agency"
          : "/profile/agent",
      admin: "/profile/admin",
      contact: "/agent/contact/profile",
      assistant: "/assistant/profile/activity",
    } as any;

    const userTyp =
      userAccess?.userType && userAccess?.isAssistant
        ? "assistant"
        : userAccess?.userType || "agent";
    const route = userTypeRoutes[userTyp];
    setSessionStore("adminProfileId", "");
    navigate(route);
  };

  const handleSettingNav = () => {
    navigate("/settings");
    dispatch(setGoingToSAManagerProfile(false));
    dispatch(setIsComingFromURL(""));
  };

  const switchToAgencyOrAgent = () => {
    if (isAgencyManagerActive) {
      removeSessionStore("agencyBrandings");
      dispatch(setIsAgent(false));
      dispatch({ type: TRIGGER_STORE_IS_AGENCY_MANAGER_ACTIVE_DATA, payload: { body: false } });
      if (userAccess?.selectedAssistantAgentOption) {
        navigate("/proposal/drafts");
      } else {
        navigate("/profile/agent");
        dispatch({
          type: GET_AGENT_PROFILE,
          payload: {
            address: "agentProfile",
          },
        });
      }
      setObjectInSessionStore("activeBrandingUser", {
        activeUserType: agentCurrentBranding || "iapp",
      });
    } else if (
      !isAgencyManagerActive &&
      userAccess?.parentAgencyId !== null &&
      !userAccess?.selectedAssistantAgentOption &&
      !userAccess?.isAssistant
    ) {
      dispatch({ type: TRIGGER_STORE_IS_AGENCY_MANAGER_ACTIVE_DATA, payload: { body: true } });
      navigate("/sub-agency/profile");
    } else if (userAccess?.selectedAssistantAgentOption) {
      dispatch({ type: TRIGGER_STORE_IS_AGENCY_MANAGER_ACTIVE_DATA, payload: { body: true } });
      navigate("/proposal/drafts");
    } else {
      dispatch({ type: TRIGGER_STORE_IS_AGENCY_MANAGER_ACTIVE_DATA, payload: { body: true } });
      dispatch({
        type: GET_AGENT_PROFILE,
        payload: {
          address: "agencyProfile",
        },
      });
      navigate("/profile/agency");
    }
    dispatch(setIsNotOwnProfile(false));

    dispatch(setGoingToSAManagerProfile(false));
  };

  const handleProfileNav = () => {
    removeSessionStore("isSetAdmin");
    navigateHandler();
    dispatch(setIsAgent(false));
    dispatch(setIsNotOwnProfile(false));
    dispatch(setGoingToSAManagerProfile(false));
    dispatch(setIsComingFromURL(""));
  };

  const logoutHandle = () => {
    dispatch(setGoingToSAManagerProfile(false));
    dispatch(setIsComingFromURL(""));
    dispatch(TriggerLogoutRequest("logout"));
    setLoader(true);
    removeLocalStore("assistantAgentUserAccess");
    dispatch(resetContactProfileLookup());
  };

  const handleformActiveCondition = () => {
    dispatch({ type: TRIGGER_STORE_IS_FORM_ACTIVE_DATA, payload: { body: false } });
    // start  of clear propoasl request forms data on click
    dispatch(resetBuySellRequestProposalData());
    dispatch(resetUserInviteDetailsState());
    dispatch(resetInsuredDefaultvalue());
    removeSessionStore("insuredPlanDetails");
    removeSessionStore("keyPersonDetails");
    removeSessionStore("insuredPlanDetailsComplete");
    removeSessionStore("buySellDetails");
    removeSessionStore("designFormData");
    removeSessionStore("otherDetails");
    removeSessionStore("splitDollarDetails");
    removeSessionStore("premiumFinanceDetails");
    removeSessionStore("currentStep");
    removeSessionStore("stepperActiveIndex");
    removeSessionStore("editFromConfirmDetails");
    removeSessionStore("preSelectedEntityId");
    removeLocalStore("contactID");
    dispatch(resetAgentContacts());
    dispatch(setActiveIndex(2));
    // end of clear propoasl request forms data on click/////////////
    setPopupDisplay(false);
    switch (actionOnDiscardChanges) {
      case "PROFILE":
        handleProfileNav();
        break;
      case "SETTING":
        handleSettingNav();
        break;
      case "SWITCH_TO_AGENCY":
        switchToAgencyOrAgent();
        break;
      default:
    }
    setTimeout(() => {
      if (isLoggingOut) {
        setPopupDisplay(true);
      }
    }, 10);

    const updatedMenu = handleMenuSelection(menu, menuCurrentId as string);
    setMenu(updatedMenu);
    if (selectedValue !== null) {
      removeLocalStore("assistantAgentUserAccess");
      dispatch({
        type: TRIGGER_SWITCH_USER,
        payload: {
          address: "authSwitchUser",
          key: selectedValue,
          body: {},
          requestParams: true,
          queryParams: false,
        },
      });
    } else {
      navigate(nextRouterUrl as string);
    }
  };

  useEffect(() => {
    if (!isEmpty(selectedValue) && selectedValue !== null) {
      if (!isFormActive) {
        removeLocalStore("assistantAgentUserAccess");
        dispatch({
          type: TRIGGER_SWITCH_USER,
          payload: {
            address: "authSwitchUser",
            key: selectedValue,
            body: {},
            requestParams: true,
            queryParams: false,
          },
        });
      } else {
        setPopupDisplay(true);
      }
    }
  }, [selectedValue]);

  const confirmationPopUpfooterContent = (
    <div>
      <Button
        label={
          (isFormActive ? t("general.button.keepEditing") : t("general.button.cancel")) as string
        }
        onClick={() => {
          setPopupDisplay(false);
          if (isLoggingOut) {
            dispatch({ type: TRIGGER_STORE_IS_FORM_ACTIVE_DATA, payload: { body: true } });
          }
          setIsLoggingOut(false);
        }}
        className="p-button-text border-gray-500 text-gray-500"
      />

      <Button
        label={
          (isFormActive ? t("general.button.discardChanges") : t("general.button.logout")) as string
        }
        className="bg-red-500 border-red-500"
        loading={loader}
        onClick={isFormActive ? handleformActiveCondition : logoutHandle}
        autoFocus
      />
    </div>
  );
  const header = isFormActive ? t("general.discardTitle") : t("general.logoutheader");
  const content = isFormActive ? t("general.discardSubTitle") : t("general.logoutcontent");

  function updateMenu(menuItemId: string) {
    const updatedMenu = handleMenuSelection(menu, menuItemId as string);
    setMenu(updatedMenu);
  }

  const toggleSidebar = async () => {
    setIsCollapsed((prev) => !prev);
    await dispatch({ type: TRIGGER_STORE_DASHBOARD_DATA, payload: { body: !isCollapsed } });
  };

  useMemo(() => {
    const updatedMenu = initializeMenu(fields, pathname);
    setMenu(updatedMenu);
  }, [fields, pathname]);

  const scrollToActiveItem = () => {
    const activeItemElement = scrollRef.current?.querySelector(".bg-layoutBlue");
    if (activeItemElement) {
      activeItemElement.scrollIntoView({ behavior: "auto", block: "center" });
    }
  };

  const handleScrollRef = (node: HTMLUListElement | null) => {
    scrollRef.current = node;
    scrollToActiveItem();
  };

  const getThemeBasedIAPPBranding = () => {
    if (isCollapsed) {
      return theme === THEME.DARK
        ? IAPPLogoDarkIcon
        : process.env.REACT_APP_ENVIRONMENT === "PROD"
        ? `${process.env.REACT_APP_ASSET_URL_PROD}/bee_icon.png`
        : `${process.env.REACT_APP_ASSET_URL_DEV}/BEE+ICON.png`;
    }
    return theme === THEME.DARK
      ? process.env.REACT_APP_ENVIRONMENT === "PROD"
        ? `${process.env.REACT_APP_ASSET_URL_PROD}/iapp_white.png`
        : `${process.env.REACT_APP_ASSET_URL_DEV}/iapp_white.png`
      : process.env.REACT_APP_ENVIRONMENT === "PROD"
      ? `${process.env.REACT_APP_ASSET_URL_PROD}/iapp_color.png`
      : `${process.env.REACT_APP_ASSET_URL_DEV}/iapp_color.png`;
  };

  useEffect(() => {
    if (userAccess?.isAssistant && !isEmpty(assistantAgentObject)) {
      setPrimaryLogo(
        agentLookUpResponse?.data?.branding?.primaryLogo ||
          agentProfile?.branding?.primaryLogo ||
          "",
      );
      setSecondaryLogo(
        agentLookUpResponse?.data?.branding?.secondaryLogo ||
          agentProfile?.branding?.secondaryLogo ||
          "",
      );
    }
  }, [agentProfile, agentLookUpResponse]);

  const getBrandingImage = () => {
    if (userAccess?.isAssistant && !isEmpty(assistantAgentObject) && primaryLogo !== "") {
      if (!isCollapsed) {
        return primaryLogo;
      }
      return secondaryLogo;
    }

    // if user is agent then show default iapp branding
    if (userAccess?.userType === USERTYPE.AGENT) {
      return getThemeBasedIAPPBranding();
    }
    if (userAccess?.userType !== USERTYPE.AGENT && userAccess?.userType !== USERTYPE.CONTACT) {
      return getThemeBasedIAPPBranding();
    }
    if (isAgencyManagerActive) {
      if (
        agencyProfileData?.agency?.currentBranding === "parentAgency" &&
        agencyProfileData?.agency?.parentAgency?.AgencyBrandings?.[0]?.[
          !isCollapsed ? "primaryLogo" : "secondaryLogo"
        ]
      ) {
        return agencyProfileData?.agency?.parentAgency?.AgencyBrandings?.[0]?.[
          !isCollapsed ? "primaryLogo" : "secondaryLogo"
        ];
      }
      if (
        agencyProfileData?.agency?.AgencyBrandings?.[0]?.[
          !isCollapsed ? "primaryLogo" : "secondaryLogo"
        ]
      ) {
        return agencyProfileData?.agency?.currentBranding === "iapp"
          ? getThemeBasedIAPPBranding()
          : agentProfileData?.agency?.AgencyBrandings?.[0]?.[
              !isCollapsed ? "primaryLogo" : "secondaryLogo"
            ];
      }
      return agencyBrandingData?.[!isCollapsed ? "primaryLogo" : "secondaryLogo"];
    }

    const image =
      agentCurrentBranding === "iapp"
        ? getThemeBasedIAPPBranding()
        : agentBrandingData
        ? agentBrandingData?.[!isCollapsed ? "primaryLogo" : "secondaryLogo"]
        : branding?.[!isCollapsed ? "primaryLogo" : "secondaryLogo"]?.length
        ? branding?.[!isCollapsed ? "primaryLogo" : "secondaryLogo"]
        : getThemeBasedIAPPBranding();

    return image;
  };

  const validLabels = [
    "Dashboard",
    "Relationship",
    "Contacts",
    "Proposals",
    "Reports",
    "Plans",
    "Pending",
    "Resources",
    "IAPP Academy",
    "Master Data",
    "HIVE Studio",
    "Subscribers",
    "Ad Center",
    "Pipeline",
    "Portfolio",
    "Financing",
    "IAM Control",
  ];

  const getMenuItemIcon = (menuItem: GroupItems): string | ReactNode => {
    const isDark = theme === "dark";
    if (menuItem.label === "IAM Control") {
      if (menuItem.isActive || isDark) {
        return beeLightSVG;
      }
      return beeDarkSVG;
    }
    if (menuItem.label === "HIVE Studio") {
      if (menuItem.isActive || isDark) {
        return hiveStudioLightSVG;
      }
      return hiveStudioDarkSVG;
    }
    if (menuItem.label === "Subscribers") {
      if (menuItem.isActive || isDark) {
        return subscribersLightSVG;
      }
      return subscribersDarkSVG;
    }
    if (menuItem.label === "Ad Center") {
      if (menuItem.isActive || isDark) {
        return adCenterLightSVG;
      }
      return adCenterDarkSVG;
    }
    if (menuItem.label === "Pipeline") {
      if (menuItem.isActive || isDark) {
        return pipelineLightSVG;
      }
      return pipelineDarkSVG;
    }
    if (menuItem.label === "Portfolio") {
      if (isNewDesignEnabled) {
        return <PortfolioIcon isActive={menuItem.isActive} />;
      }
      return menuItem.isActive || isDark ? portfolioLightSVG : portfolioDarkSVG;
    }

    if (menuItem.label === "Master Data") {
      if (menuItem.isActive || isDark) {
        return masterDataLightSVG;
      }
      return masterDataDarkSVG;
    }
    if (menuItem.label === "Dashboard") {
      if (menuItem.isActive || isDark) {
        return dashboardDarkSVG;
      }
      return dashboardSVG;
    }

    if (menuItem.label === "Relationship") {
      return <RelationshipIcon isActive={menuItem.isActive} />;
    }

    if (menuItem.label === "Contacts") {
      if (menuItem.isActive || isDark) {
        return contactsSVG;
      }
      return contactsDarkSVG;
    }
    if (menuItem.label === "Proposals") {
      if (isDark) {
        return proposalsSVG;
      }
      return proposalsDarkSVG;
    }
    // Pending icon logic
    if (menuItem.label === "Pending") {
      if (isDark) {
        return pendingLightSVG;
      }
      return pendingSVG;
    }
    // Plans icon logic — use PortfolioIcon component when new design is enabled
    if (menuItem.label === "Plans") {
      if (isNewDesignEnabled) {
        return <PortfolioIcon isActive={menuItem.isActive} />;
      }
      const isAgent = userAccess?.userType === USERTYPE.AGENT;
      const shouldUseLightIcon = isDark || (isAgent && menuItem.isActive);
      return shouldUseLightIcon ? plansLightSVG : plansSVG;
    }

    if (menuItem.label === "Reports") {
      if (menuItem.isActive || isDark) {
        return reportsSVG;
      }
      return reportsDarkSVG;
    }

    // IAPP Academy icon logic
    if (menuItem.label === "IAPP Academy") {
      if (menuItem.isActive || isDark) {
        return educationLightSVG;
      }
      return educationDarkSVG;
    }

    // Resources icon logic (default)
    return isDark ? resourcesLightSVG : resourcesSVG;
  };

  const getColor = (menuItem: SidebarSubItem) => {
    if (menuItem.isActive) {
      return theme === "dark" ? "#63B3ED" : "#3B82F6";
    }
    return theme === "dark" ? "white" : "black";
  };

  const subMenuImage = (menuItem: SidebarSubItem) => {
    // console.log("menuItem", menuItem.label);
    if (menuItem.label === "Financing") {
      return <FinancingIcon fill={getColor(menuItem)} size={22} />;
    }
    if (menuItem.label === "Pending") {
      return <PendingIcon fill={getColor(menuItem)} height={22} width={22} />;
    }
    if (menuItem.label === "Proposals") {
      return <ProposalsIcon fill={getColor(menuItem)} size={21} />;
    }
    if (menuItem.label === "Plans") {
      if (isNewDesignEnabled) {
        return <PortfolioIcon isActive={menuItem.isActive} fill={getColor(menuItem)} size={20} />;
      }
      return <PlanIcon fill={getColor(menuItem)} size={20} />;
    }
    if (
      [
        "Milestones",
        "Insurance Companies",
        "AFR",
        "Provisions",
        "Buy Sell Provisions",
        "Subscribers",
      ].includes(menuItem.label)
    ) {
      return (
        <img
          src={
            theme === "dark"
              ? menuItem.label === "Milestones"
                ? milestonesLightSVG
                : menuItem.label === "Insurance Companies"
                ? insuranceCompanyLightSVG
                : menuItem.label === "AFR"
                ? afrLightSVG
                : provisionsLightSVG
              : menuItem.label === "Milestones"
              ? milestonesDarkSVG
              : menuItem.label === "Insurance Companies"
              ? insuranceCompanyDarkSVG
              : menuItem.label === "AFR"
              ? afrDarkSVG
              : provisionsDarkSVG
          }
          alt={`${menuItem.label.toLowerCase()}-icon`}
          style={{
            filter: menuItem.isActive
              ? "brightness(0) saturate(100%) invert(46%) sepia(75%) saturate(1595%) hue-rotate(199deg) brightness(96%) contrast(93%)"
              : "none",
          }}
        />
      );
    }
    return null;
  };

  const shouldRenderInlineSubmenu = (menuItem: GroupItems) =>
    !(
      (isNewDesignEnabled && menuItem.label === "Portfolio") ||
      (menuItem.label === "Pipeline" && isNewDesignEnabled)
    );

  const handleThemeClick = (selectedTheme: string) => {
    dispatch({
      type: TRIGGER_SAVE_THEME_SETTINGS,
      payload: {
        address: "saveThemeSettings",
        body: { theme: selectedTheme },
      },
    });
    setTheme(selectedTheme);
    setThemeState(selectedTheme);
    setSessionStore("globalTheme", selectedTheme);
    PrimeReact?.changeTheme?.(
      `lara-${theme}-blue`,
      `lara-${selectedTheme}-blue`,
      "app-theme",
      () => {
        const allThemeLinks = document.querySelectorAll("link#app-theme");
        if (allThemeLinks.length > 1) {
          for (let i = 1; i < allThemeLinks.length; i++) {
            allThemeLinks[i].remove();
          }
        }
      },
    );
  };

  const profileItems = [
    {
      label: "Profile",
      icon: "pi pi-user inherit-menuIcon-color",
      command: () => {
        if (isFormActive) {
          setPopupDisplay(true);
          setActionOnDiscardChanges("PROFILE");
        } else {
          handleProfileNav();
        }
      },
    },
    {
      label: "Settings",
      icon: "pi pi-cog inherit-menuIcon-color",
      command: () => {
        if (isFormActive) {
          setPopupDisplay(true);
          setActionOnDiscardChanges("SETTING");
        } else {
          handleSettingNav();
        }
      },
    },
    ...(userAccess.agencyManager || assistantAgentObject?.agencyManager
      ? [
          {
            label: !assistantAgentObject?.selectedAssistantAgentOption
              ? userAccess?.parentAgencyId !== null &&
                !isAgencyManagerActive &&
                isEmpty(agencyBranding)
                ? "Switch to Sub-Agency"
                : isAgencyManagerActive || !isEmpty(agencyBranding)
                ? "Switch to Advisor"
                : "Switch to Agency"
              : assistantAgentObject?.parentAgencyId !== null &&
                !isAgencyManagerActive &&
                isEmpty(agencyBranding)
              ? "Switch to Sub-Agency"
              : assistantAgentObject?.agencyManager && !isAgencyManagerActive
              ? "Switch to Agency"
              : "Switch to Advisor",
            icon: "pi pi-arrow-right inherit-menuIcon-color",
            command: () => {
              if (isFormActive) {
                setPopupDisplay(true);
                setActionOnDiscardChanges("SWITCH_TO_AGENCY");
              } else {
                switchToAgencyOrAgent();
              }
            },
            className:
              isAgencyManagerActive || !isEmpty(agencyBranding)
                ? "common-custom-styles"
                : "common-custom-styles switch-to-agency",
          },
        ]
      : []),
    {
      separator: true,
    },
    {
      label: "Logout",
      template: (item: any) => (
        <div
          className="logout-btn flex items-center cursor-pointer px-3 ml-1 py-1 hover:bg-red-100 dark:hover:!bg-red-100 rounded-md"
          onClick={() => {
            setPopupDisplay(true);
            if (isFormActive) {
              setIsLoggingOut(true);
            }
          }}
        >
          <div className="w-[20px] h-[20px] mr-2">
            <ExitIcon fill="#e24c4c" />
          </div>
          <span className="text-red-500">{item.label}</span>
        </div>
      ),
      className: "logout-btn",
    },
  ];

  const profilePic =
    lookupData?.profilePicture || localLookup?.profilePicture || defaultProfilePicture;

  const updatedMenu = useMemo(() => {
    let filteredMenu = menu;

    // Filter Dashboard and Team for agency manager
    if (isAgencyManagerActive || (userAccess?.parentAgencyId !== null && isAgencyManagerActive)) {
      filteredMenu = menu.map((group) => ({
        ...group,
        groupItems: group.groupItems.filter(
          (item) => item.label !== "Dashboard" && item.label !== "Team",
        ),
      }));
    }

    // Filter Reports group entirely for assistant users based on localStorage value
    if (userAccess?.isAssistant && !shouldShowReports) {
      filteredMenu = filteredMenu.filter((group) => group.groupName !== "reportsGroup");
    }

    return filteredMenu;
  }, [menu, isAgencyManagerActive, userAccess, shouldShowReports]);

  const advisorName = `${lookupData?.profile?.firstName || ""} ${
    lookupData?.profile?.lastName || ""
  }`;

  return (
    <aside className="dashboard-sidebar">
      <Sidebar
        visible={visible}
        closeOnEscape={false}
        className="dark:!text-dark-color"
        showCloseIcon={false}
        modal={false}
        dismissable={false}
        onHide={() => setVisible(false)}
        appendTo={document.getElementById("sidebar")}
      >
        <div className=" ">
          <div className="relative">
            <i
              className={`pi ${
                isCollapsed ? "pi-angle-double-right" : "pi-angle-double-left"
              } absolute top-[54px] right-[-22px] cursor-pointer`}
              style={{ color: "#1581ED", fontSize: "19px" }}
              onClick={toggleSidebar}
            />
            <Tooltip target=".toggle-btn" position="right">
              {isCollapsed ? "Expand" : "Collapse"}
            </Tooltip>
          </div>
          <div className="branding flex justify-center mb-4">
            <img
              key={`${isAgencyManagerActive}${(agentBrandingData as any)?.id}`}
              src={getBrandingImage()}
              className={isCollapsed ? "pb-3 h-[4rem] mb-4" : `h-20`}
              alt="header-logo"
            />
          </div>
          <div className="flex justify-center items-center">
            <ul
              ref={handleScrollRef}
              className={`sidebarList leftPanelUl overflow-y-auto flex flex-col items-center ${
                isCollapsed ? "!w-[55px] overflow-x-hidden" : "w-full"
              }`}
              style={{
                height:
                  userAccess?.userType === USERTYPE.AGENT
                    ? `calc(100vh - ${userAccess?.isAssistant ? "350px" : "250px"})`
                    : "calc(100vh - 150px)",
              }}
            >
              {updatedMenu && (
                <li
                  className={`${
                    isCollapsed
                      ? "!w-[50px]  flex flex-col items-center justify-centerpx-2 rounded-md"
                      : ""
                  }`}
                >
                  {updatedMenu.map((group: SidebarItem) => (
                    <ul key={`${group?.id}-${group.groupName}`} className="leftPanelUl">
                      <li>
                        <ul className="leftPanelUl conthrax-font text-base">
                          {group.groupItems?.map((menuItem: GroupItems) => {
                            const key = `${menuItem?.id}-${menuItem.groupName}`;
                            return (
                              <li
                                key={key}
                                className={`${
                                  isCollapsed ? "mb-4 flex justify-center items-center" : ""
                                }`}
                              >
                                <div
                                  className={`
                                    flex flex-col overflow-visible
                                    ${isCollapsed ? "items-center" : ""}
                                  `}
                                >
                                  <a
                                    href={`${process.env.PUBLIC_URL}/#${
                                      menuItem?.groupItems?.length
                                        ? menuItem?.link
                                          ? `${
                                              menuItem?.link
                                            }/${menuItem?.groupItems[0]?.label.replace(
                                              /\s/g,
                                              "",
                                            )}`.toLowerCase()
                                          : `${menuItem?.groupItems[0]?.link}`
                                        : menuItem?.link
                                    }`}
                                    className={`p-[12px] block rounded-lg cursor-pointer ${
                                      isCollapsed
                                        ? `menu-${menuItem?.id}-item-icon p-1 !w-[35px] !h-[35px] flex justify-center items-center rounded-md`
                                        : ""
                                    } ${
                                      !menuItem?.isActive &&
                                      "hover:bg-gray-200 dark:hover:!bg-gray-800 "
                                    } ${
                                      menuItem?.isActive || expandedMenuId === menuItem.id
                                        ? "bg-layoutBlue text-white nav-active"
                                        : ""
                                    }`}
                                    onClick={(e) => {
                                      if (isCollapsed) {
                                        e.preventDefault();
                                        e.stopPropagation();

                                        // Clear all previous selections first
                                        menu.forEach((menuGroup) => {
                                          menuGroup.groupItems.forEach((item) => {
                                            item.isActive = false;
                                            item.groupItems?.forEach((subItem) => {
                                              subItem.isActive = false;
                                            });
                                          });
                                        });

                                        // If this menu item has submenus
                                        if (menuItem.groupItems?.length) {
                                          // If clicking the same menu item that's already expanded
                                          if (expandedMenuId === menuItem.id) {
                                            setExpandedMenuId(null);
                                          } else {
                                            // Set current menu active and expand it
                                            menuItem.isActive = true;
                                            // In new design, Portfolio should not expand sub-types
                                            if (
                                              menuItem.label === "Portfolio" &&
                                              isNewDesignEnabled
                                            ) {
                                              if (menuItem?.link) {
                                                navigate(menuItem.link);
                                              }
                                            } else if (
                                              menuItem?.groupItems &&
                                              menuItem.groupItems.length > 0
                                            ) {
                                              const firstSubmenuItem = menuItem.groupItems[0];
                                              firstSubmenuItem.isActive = true;
                                              if (menuItem?.link) {
                                                navigate(
                                                  `${
                                                    menuItem?.link
                                                  }/${firstSubmenuItem?.label?.replace(
                                                    /\s/g,
                                                    "",
                                                  )}`.toLowerCase(),
                                                );
                                              } else {
                                                navigate(`${firstSubmenuItem?.link}`);
                                              }
                                            }
                                            setExpandedMenuId(
                                              menuItem.label === "Portfolio" && isNewDesignEnabled
                                                ? null
                                                : menuItem.id,
                                            );
                                          }
                                        } else {
                                          // For menu items without submenus
                                          menuItem.isActive = true;
                                          setExpandedMenuId(null); // Collapse any expanded submenu
                                          if (menuItem?.link) {
                                            navigate(menuItem.link);
                                          }
                                        }
                                        setMenu([...menu]);
                                      } else if (isFormActive === false) {
                                        // Clear previous selections
                                        menu.forEach((menuGroup) => {
                                          menuGroup.groupItems.forEach((item) => {
                                            if (item.id !== menuItem.id) {
                                              item.isActive = false;
                                              item.groupItems?.forEach((subItem) => {
                                                subItem.isActive = false;
                                              });
                                            }
                                          });
                                        });

                                        // Set current menu as active and select first submenu item
                                        menuItem.isActive = true;
                                        // Only auto-select first submenuPortfolio (legacy)
                                        if (
                                          menuItem?.groupItems &&
                                          menuItem.groupItems.length > 0 &&
                                          (menuItem.label === "Pipeline" ||
                                            (menuItem.label === "Portfolio" && !isNewDesignEnabled))
                                        ) {
                                          const firstSubmenuItem = menuItem.groupItems[0];
                                          firstSubmenuItem.isActive = true;

                                          // Navigate to the first submenu item
                                          if (menuItem?.link) {
                                            navigate(
                                              `${menuItem?.link}/${firstSubmenuItem?.label?.replace(
                                                /\s/g,
                                                "",
                                              )}`.toLowerCase(),
                                            );
                                          } else {
                                            navigate(`${firstSubmenuItem?.link}`);
                                          }
                                        }

                                        // In new design, Portfolio navigates without sub-types
                                        if (
                                          menuItem.label === "Portfolio" &&
                                          isNewDesignEnabled &&
                                          menuItem?.link
                                        ) {
                                          navigate(menuItem.link);
                                        }

                                        setMenu([...menu]);
                                        dispatch(setGoingToSAManagerProfile(false));
                                        dispatch(setIsComingFromURL(""));
                                      } else {
                                        e.preventDefault();
                                        setPopupDisplay(true);
                                        setMenuCurrentId(menuItem.id);
                                        setNextRouterUrl(
                                          `${
                                            menuItem?.groupItems?.length
                                              ? `${
                                                  menuItem?.link
                                                }/${menuItem?.groupItems[0]?.label.replace(
                                                  /\s/g,
                                                  "",
                                                )}`.toLowerCase()
                                              : menuItem?.link
                                          }`,
                                        );
                                      }
                                    }}
                                  >
                                    {validLabels.includes(menuItem?.label) ? (
                                      <>
                                        <div
                                          className={`flex ${
                                            isCollapsed
                                              ? "justify-center items-center"
                                              : "justify-between"
                                          }`}
                                        >
                                          <div className="flex items-center justify-center">
                                            <div
                                              className={`relative ${
                                                isCollapsed
                                                  ? "w-[18px] h-[18px] flex justify-center items-center"
                                                  : "w-[25px] h-[25px] pr-2"
                                              } `}
                                            >
                                              {isCollapsed &&
                                                Array.isArray(menuItem?.groupItems) &&
                                                menuItem.groupItems.length > 0 &&
                                                shouldRenderInlineSubmenu(menuItem) &&
                                                menuItem.label !== "Portfolio" && (
                                                  <div className="absolute -right-1 -bottom-1 w-2 h-2 bg-blue-500 rounded-full" />
                                                )}
                                              {typeof getMenuItemIcon(menuItem) === "string" ? (
                                                <img
                                                  src={getMenuItemIcon(menuItem) as string}
                                                  alt={`${menuItem?.label}-icon`}
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "contain",
                                                    objectPosition: "center",
                                                  }}
                                                />
                                              ) : (
                                                getMenuItemIcon(menuItem)
                                              )}
                                            </div>
                                            {!isCollapsed && (
                                              <span
                                                className={`${
                                                  menuItem?.isActive && menuItem?.groupItems
                                                    ? "!text-white"
                                                    : ""
                                                } text-sm`}
                                              >
                                                {isNewDesignEnabled && menuItem?.label === "Plans"
                                                  ? "Portfolio"
                                                  : menuItem?.label === "Relationship"
                                                  ? "Relationships"
                                                  : menuItem?.label}
                                              </span>
                                            )}
                                          </div>
                                          {badgeCount && menuItem.label in badgeCount && (
                                            <span>
                                              {!isCollapsed &&
                                                badgeCount &&
                                                menuItem.label in badgeCount &&
                                                badgeCount?.[menuItem.label] > 0 && (
                                                  <span className="mr-1 !text-sm">
                                                    <Badge severity="info" />
                                                  </span>
                                                )}
                                              {!isCollapsed &&
                                                menuItem?.groupItems?.length &&
                                                shouldRenderInlineSubmenu(menuItem) && (
                                                  <button
                                                    className="float-right !w-8 h-8 rounded-full hover:bg-gray-100 hover:text-blue-500"
                                                    type="button"
                                                    onClick={handleButtonClick}
                                                  >
                                                    <i
                                                      aria-label="up/down"
                                                      className={`pi ${
                                                        menuItem.isActive && isBlockVisible
                                                          ? "pi-angle-up"
                                                          : "pi-angle-down"
                                                      }`}
                                                    />
                                                  </button>
                                                )}
                                            </span>
                                          )}
                                        </div>
                                      </>
                                    ) : (
                                      <span
                                        className={`flex ${
                                          isCollapsed
                                            ? "items-center justify-center"
                                            : "justify-between"
                                        }`}
                                      >
                                        <span
                                          className={`flex w-full items-center ${
                                            isCollapsed ? "justify-center" : "justify-start"
                                          }`}
                                        >
                                          <i
                                            className={`pi ${menuItem?.icon} ${
                                              !isCollapsed && "pr-2"
                                            }`}
                                          />
                                          {!isCollapsed && (
                                            <span className="text-sm">{menuItem?.label}</span>
                                          )}
                                        </span>
                                        {!isCollapsed &&
                                          badgeCount &&
                                          menuItem.label in badgeCount &&
                                          badgeCount?.[menuItem.label] > 0 && (
                                            <span>
                                              <span className="mr-1 !text-sm">
                                                <Badge severity="info" />
                                              </span>
                                              {!isCollapsed &&
                                                menuItem?.groupItems?.length &&
                                                shouldRenderInlineSubmenu(menuItem) && (
                                                  <button
                                                    className="!w-8 h-8 rounded-full hover:bg-gray-100 hover:text-blue-500"
                                                    type="button"
                                                    onClick={handleButtonClick}
                                                  >
                                                    <i
                                                      aria-label="up/down"
                                                      className={`pi ${
                                                        menuItem.isActive && isBlockVisible
                                                          ? "pi-angle-up"
                                                          : "pi-angle-down"
                                                      }`}
                                                    />
                                                  </button>
                                                )}
                                            </span>
                                          )}
                                      </span>
                                    )}
                                  </a>
                                  {isCollapsed ? (
                                    <Tooltip
                                      target={`.menu-${menuItem?.id}-item-icon`}
                                      position="right"
                                    >
                                      {isNewDesignEnabled && menuItem?.label === "Plans"
                                        ? "Portfolio"
                                        : menuItem?.label}
                                    </Tooltip>
                                  ) : null}
                                  {isCollapsed &&
                                    expandedMenuId === menuItem.id &&
                                    Array.isArray(menuItem?.groupItems) &&
                                    menuItem.groupItems.length > 0 &&
                                    shouldRenderInlineSubmenu(menuItem) && (
                                      <div className="w-[50px] mt-2 dark:bg-gray-800 rounded-md py-2">
                                        <ul className="flex flex-col items-center w-full ml-2 border-l border-gray-300 pt-2 overflow-visible">
                                          {menuItem.groupItems.map(
                                            (submenuItem: SidebarSubItem) => (
                                              <li
                                                key={`${submenuItem?.id}-${submenuItem?.label}`}
                                                className={`w-[35px] h-[40px] mb-2 flex justify-center items-center overflow-visible
                                                  cursor-pointer rounded-md
                                                  hover:bg-gray-100 dark:hover:bg-gray-700
                                                  ${submenuItem.isActive ? "text-blue-500" : ""}
                                                  ${
                                                    theme === "dark"
                                                      ? "text-white"
                                                      : "text-gray-800"
                                                  }`}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  if (isFormActive === false) {
                                                    // Clear all other menu selections
                                                    menu.forEach((menuGroup) => {
                                                      menuGroup.groupItems.forEach((item) => {
                                                        if (item.id !== menuItem.id) {
                                                          item.isActive = false;
                                                          item.groupItems?.forEach((subItem) => {
                                                            subItem.isActive = false;
                                                          });
                                                        }
                                                      });
                                                    });

                                                    // Set current menu and submenu as active
                                                    menuItem.isActive = true;
                                                    menuItem.groupItems?.forEach((subItem) => {
                                                      subItem.isActive =
                                                        subItem.id === submenuItem.id;
                                                    });
                                                    setMenu([...menu]);
                                                    if (menuItem?.link) {
                                                      navigate(
                                                        `${
                                                          menuItem?.link
                                                        }/${submenuItem?.label?.replace(
                                                          /\s/g,
                                                          "",
                                                        )}`.toLowerCase(),
                                                      );
                                                    } else {
                                                      navigate(`${submenuItem?.link}`);
                                                    }
                                                  } else {
                                                    setPopupDisplay(true);
                                                    setMenuCurrentId(menuItem.id);
                                                    setNextRouterUrl(
                                                      `${
                                                        menuItem.link
                                                      }/${submenuItem?.label?.replace(
                                                        /\s/g,
                                                        "",
                                                      )}`.toLowerCase(),
                                                    );
                                                  }
                                                }}
                                              >
                                                <div className="flex items-center justify-center">
                                                  {[
                                                    "Milestones",
                                                    "Insurance Companies",
                                                    "AFR",
                                                    "Provisions",
                                                    "Buy Sell Provisions",
                                                  ].includes(submenuItem.label) ? (
                                                    <>
                                                      <img
                                                        src={
                                                          theme === "dark"
                                                            ? submenuItem.label === "Milestones"
                                                              ? milestonesLightSVG
                                                              : submenuItem.label ===
                                                                "Insurance Companies"
                                                              ? insuranceCompanyLightSVG
                                                              : submenuItem.label === "AFR"
                                                              ? afrLightSVG
                                                              : provisionsLightSVG
                                                            : submenuItem.label === "Milestones"
                                                            ? milestonesDarkSVG
                                                            : submenuItem.label ===
                                                              "Insurance Companies"
                                                            ? insuranceCompanyDarkSVG
                                                            : submenuItem.label === "AFR"
                                                            ? afrDarkSVG
                                                            : provisionsDarkSVG
                                                        }
                                                        alt={`${submenuItem.label.toLowerCase()}-icon`}
                                                        style={{
                                                          width: "20px",
                                                          height: "20px",
                                                          filter: submenuItem.isActive
                                                            ? "brightness(0) saturate(100%) invert(46%) sepia(75%) saturate(1595%) hue-rotate(199deg) brightness(96%) contrast(93%)"
                                                            : "none",
                                                        }}
                                                        className={`menu-${submenuItem.id}-icon`}
                                                      />
                                                      <Tooltip
                                                        target={`.menu-${submenuItem.id}-icon`}
                                                        position="right"
                                                      >
                                                        {submenuItem.label}
                                                      </Tooltip>
                                                    </>
                                                  ) : validLabels.includes(submenuItem?.label) ? (
                                                    <span
                                                      className={`
                                                        w-[20px] h-[20px]
                                                        flex items-center justify-center rounded-sm
                                                      `}
                                                    >
                                                      {subMenuImage(submenuItem)}
                                                    </span>
                                                  ) : (
                                                    <i
                                                      className={`pi ${submenuItem?.icon}`}
                                                      style={{ fontSize: "20px" }}
                                                    />
                                                  )}
                                                  {badgeCount &&
                                                    submenuItem?.label in badgeCount &&
                                                    badgeCount?.[submenuItem?.label] > 0 && (
                                                      <Badge
                                                        {...(submenuItem?.label === "Pending" ||
                                                        submenuItem?.label === "Proposals"
                                                          ? {}
                                                          : {
                                                              value:
                                                                badgeCount?.[submenuItem?.label],
                                                            })}
                                                        severity="info"
                                                        className="ml-2"
                                                      />
                                                    )}
                                                </div>
                                              </li>
                                            ),
                                          )}
                                        </ul>
                                      </div>
                                    )}
                                </div>
                                {!isCollapsed &&
                                  menuItem?.groupItems?.length &&
                                  shouldRenderInlineSubmenu(menuItem) &&
                                  (menuItem?.isActive ||
                                    menuItem?.groupItems?.find((item) => item.isActive)) &&
                                  isBlockVisible && (
                                    <ul className="ml-4 mt-2 border-l border-gray-300 leftPanelUl">
                                      {menuItem.groupItems.map((submenuItem: SidebarSubItem) => (
                                        <li
                                          key={`${submenuItem?.id}-${submenuItem?.label}`} // {submenuItem.id}
                                          onClick={(e) => {
                                            if (isFormActive === false) {
                                              updateMenu(menuItem?.id);
                                              if (menuItem?.link) {
                                                navigate(
                                                  `${menuItem?.link}/${submenuItem?.label?.replace(
                                                    /\s/g,
                                                    "",
                                                  )}`.toLowerCase(),
                                                );
                                              } else {
                                                navigate(`${submenuItem?.link}`);
                                              }
                                            } else {
                                              e.preventDefault();
                                              setPopupDisplay(true);
                                              setMenuCurrentId(menuItem.id);
                                              setNextRouterUrl(
                                                `${`${menuItem.link}/${submenuItem?.label?.replace(
                                                  /\s/g,
                                                  "",
                                                )}`.toLowerCase()}`,
                                              );
                                            }
                                            // updateMenu(submenuItem.id);
                                          }}
                                        >
                                          <p
                                            className={`p-3 block rounded-lg cursor-pointer flex items-center justify-between ${
                                              !submenuItem?.isActive &&
                                              "hover:text-gray-700 dark:hover:!text-gray-500"
                                            } ${
                                              submenuItem.isActive
                                                ? "text-blue-500 dark:!text-blue-400"
                                                : ""
                                              // : "bg-white hover:bg-gray-200"
                                            }`}
                                          >
                                            {menuItem.link ? (
                                              <span className="text-sm">{submenuItem.label}</span>
                                            ) : (
                                              <div className="flex items-center">
                                                {validLabels.includes(submenuItem?.label) ? (
                                                  <span className="w-[18px] mr-1">
                                                    {subMenuImage(submenuItem)}
                                                  </span>
                                                ) : (
                                                  <i
                                                    className={`pi ${submenuItem?.icon}`}
                                                    style={{ fontSize: "20px" }}
                                                  />
                                                )}

                                                <span className="ml-1 text-sm">
                                                  {submenuItem?.label}
                                                </span>
                                              </div>
                                            )}

                                            {badgeCount &&
                                              submenuItem?.label in badgeCount &&
                                              badgeCount?.[submenuItem?.label] > 0 && (
                                                <span
                                                  className={`items-center ${
                                                    submenuItem?.isActive
                                                      ? "text-layoutBlue"
                                                      : "text-white"
                                                  } `}
                                                >
                                                  <Badge
                                                    {...(submenuItem?.label === "Pending" ||
                                                    submenuItem?.label === "Proposals"
                                                      ? {}
                                                      : {
                                                          value: badgeCount?.[submenuItem?.label],
                                                        })}
                                                    severity="info"
                                                    pt={
                                                      submenuItem.label === "Pending" ||
                                                      submenuItem.label === "Proposals"
                                                        ? {}
                                                        : {
                                                            root: {
                                                              className: `${
                                                                badgeCount?.[submenuItem.label] <= 9
                                                                  ? "px-3"
                                                                  : badgeCount?.[
                                                                      submenuItem?.label
                                                                    ] <= 99
                                                                  ? "px-[12px]"
                                                                  : ""
                                                              } border-round-md`,
                                                            },
                                                          }
                                                    }
                                                  />
                                                </span>
                                              )}
                                          </p>
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                              </li>
                            );
                          })}
                        </ul>
                      </li>
                      {group.groupName === "connection" ? null : (
                        <li>
                          <Divider className="custom-divider" />
                        </li>
                      )}
                    </ul>
                  ))}
                </li>
              )}
            </ul>
          </div>
          {userAccess?.userType === USERTYPE.AGENT && (
            <div className="border-gray-300 border-t-[1px] pt-2">
              <div className="flex justify-center">
                <ThemeSelector
                  themeState={themeState || theme}
                  handleThemeClick={handleThemeClick}
                  isExpanded={!isCollapsed}
                  tooltipPosition="top"
                  textClass="text-xs conthrax-font"
                />
              </div>
              <div className={`${!isCollapsed ? "flex items-center ml-2" : "ml-1"} mt-3`}>
                <div className="flex-shrink-0">
                  <HexagonImage
                    imageUrl={profilePic}
                    imageSize={50}
                    borderColor="#ffffff"
                    boxShadowColor="#49ABF3"
                    boxShadowWidth={7}
                    onClick={(e) => menuRef.current?.toggle(e)}
                    className="cursor-pointer"
                  />
                </div>
                {!isCollapsed && (
                  <div className="conthrax-font ml-3 min-w-0 flex-1">
                    {advisorName.length > 1 ? (
                      <TruncatedText
                        text={advisorName}
                        tooltipId={`sidebar-${advisorName}`}
                        tooltipPosition="top"
                        maxWidth="max-w-full"
                      />
                    ) : (
                      <Skeleton className="mb-2" width="7rem" height="15px" />
                    )}
                    {advisorName.length > 1 ? (
                      <p className="text-[10px] truncate max-w-full">
                        {userTypeForAdvisor(isAgencyManagerActive)}
                      </p>
                    ) : (
                      <Skeleton width="5rem" height="10px" />
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
          {userAccess?.isAssistant && (
            <div className="absolute bottom-0 w-full left-0 pb-3 px-3">
              <label htmlFor="assignAssistantAgent" className="text-sm">
                Select an advisor to work for:
              </label>
              <Dropdown
                inputId="assignAssistantAgent"
                value={selectedValue || assistantAgentObject?.selectedAssistantAgentOption}
                placeholder="Select an advisor to work"
                options={assistantAgentListNames}
                onChange={(e) => {
                  setSelectedValue(e.value);
                }}
                className="w-full"
              />
            </div>
          )}
          {popUpDisplay && (
            <BlockPopup
              visible={popUpDisplay}
              footerContent={confirmationPopUpfooterContent}
              header={header}
              content={content}
            />
          )}
        </div>
      </Sidebar>
      <Toast ref={toast} position="top-center" />
      <TieredMenu model={profileItems} popup ref={menuRef} breakpoint="767px" />
    </aside>
  );
};

export default DashboardLeftPanel;
